import React, { useEffect, useState } from "react";
import { MDBIcon } from "mdbreact";
import {
  Card,
  CardBody,
  CardHeader,
  Pagination,
  PaginationItem,
  PaginationLink,
  Table,
  Container,
  Row,
  Col,
  Label,
  CardFooter,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  FormGroup,
  Input
} from "reactstrap";
import 'assets/custom/custom.css';
import axios from "utils/api";
import pageShowing from "utils/pageShowing";
import moment from 'moment';

const TransactionInquiry = props => {
  const authSession = JSON.parse(localStorage.getItem('auth'));
  const [transactions, setTransactions] = useState({ dataRows: [], dataCount: 0, currentPage: 1 });
  const [page, setPage] = useState({ currentPage: 1, pageSize: 10, totalCount: 0 });
  const [qrSource] = useState();
  const [modal] = useState(false);
  const [modalTitle] = useState();
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [tidDropDownOpen, setTidDropDownOpen] = useState(false);
  const [midDropDownOpen, setMidDropDownOpen] = useState(false);
  const [midProfiles, setMIDProfiles] = useState([]);
  const [tidProfiles, setTIDProfiles] = useState([]);
  const [statuses, setStatuses] = useState([]);
  const [coverageText, setCoverageText] = useState();
  const toggle = () => setDropdownOpen(prevState => !prevState);
  const toggleTid = () => setTidDropDownOpen(prevState => !prevState);
  const toggleMID = () => setMidDropDownOpen(prevState => !prevState);
  const [searchParam, setSearchParam] = useState({
    accountId: '',
    startDate: '',
    endDate: '',
    mid: '',
    tid: '',
    coverage: '',
    status: '',
    txnRefNo: '',
    currentPage: 1,
    pageSize: 5
  });

  useEffect(() => {
    let mounted = true;

    if (mounted) {
      getMIDProfiles();
      getStatus();

      var auditlog = {
        moduleName: `Transaction Inquiry`,
        accountId: authSession.merchantGroupCode,
        username: authSession.username,
        actionsTaken: `Viewed transaction inquiry list`
      };

      axios.post('auditlog/add', { auditlog: auditlog }).then((response) => { });
    }

    return () => {
      mounted = false;
    };
  }, []);

  const pageNumbers = [];

  const getTransactions = (currentPage) => {
    const parameters = {
      accountId: authSession?.merchantGroupCode,
      startDate: searchParam.startDate,
      endDate: searchParam.endDate,
      mid: searchParam.mid,
      tid: searchParam.tid,
      coverage: searchParam.coverage,
      status: searchParam.status,
      txnRefNo: searchParam.txnRefNo,
      currentPage: currentPage,
      pageSize: searchParam.pageSize
    };

    if (parameters.mid === '')
      parameters.mid = midProfiles[0].value;

    if (parameters.tid === '')
      parameters.tid = tidProfiles[0].id;

    axios.get(`/transactioninquiry/gettransactions`, { params: parameters })
      .then(response => {
        const totalItems = response.data.totalItems;

        setTransactions({
          dataRows: response.data.transactions,
          dataCount: totalItems,
          currentPage: parameters.currentPage
        });

        setPage(page => ({
          ...page,
          currentPage: parameters.currentPage,
          pageSize: parameters.pageSize,
          totalCount: totalItems
        }));
      }).catch(() => {
        console.log('There is a problem fetching the transactions. Please try again later.');
      });
  };

  const getMIDProfiles = () => {

    axios.get(`user/getmids?accountId=${authSession.merchantGroupCode}&portaluserid=${authSession.portalUserId}`)
      .then(response => {
        setMIDProfiles(response.data.mids);
        getTIDProfiles(response.data.mids[0].value);
      }).catch(() => {
        console.log('There is a problem fetching the MIDs. Please try again later.');
      });

  };

  const getTIDProfiles = (mid) => {
    axios.get(`/user/gettids?accountId=${mid}`)
      .then(response => {
        setTIDProfiles(response.data.tids);
      }).catch(() => {
        console.log('There is a problem fetching the TIDs. Please try again later.');
      });
  };

  const getStatus = () => {
    axios.get(`/transactioninquiry/getstatus?accountId=${authSession.merchantGroupCode}`)
      .then(response => {
        setStatuses(response.data.statuses);
      }).catch(() => {
        console.log('There is a problem fetching the statuses. Please try again later.');
      });
  };


  const handleTidText = (event) => {
    //setTidText(event.value);

    handeSearchParamChange('tid', event.value);
  };

  const handleDropdownChange = (name, value) => {
    setSearchParam(searchParam => ({
      ...searchParam, [name]: value
    }));
  };


  const handleCoverageText = (event) => {

    if (event.value == 1) {
      setCoverageText('Last 3 transactions');
      handeSearchParamChange('coverage', 3);

    }
    else if (event.value == 2) {
      setCoverageText('Last 5 transactions');
      handeSearchParamChange('coverage', 5);
    }
    else {
      setCoverageText('Last 10 transactions');
      handeSearchParamChange('coverage', 10);
    }

  };

  const handeSearchParamChange = (param, value) => {
    setSearchParam(searchParam => ({
      ...searchParam, [param]: value
    }));
  };


  const handleChange = (event, value, param) => {
    event.persist();
    if (param == "mid") {
      getTIDProfiles(value);
    }
    setSearchParam(searchParam => ({
      ...searchParam, [param]: value
    }));
  };

  const handlePageChange = (event) => {
    if (!(event.value < 1 || event.value > pageNumbers[pageNumbers.length - 1])) {
      getTransactions(event.value);
    }
  };

  const renderMIDOptions = () => {
    return midProfiles?.map((mid) => {
      return (
        <option value={mid.value} onClick={() => handleDropdownChange({ name: 'mid', value: mid.value })}>{mid.label}</option>
      );
    });
  }

  const renderTIDOptions = () => {
    return tidProfiles?.map((tid) => {
      return (
        <option value={tid.id} onClick={() => handleDropdownChange({ name: 'tid', value: tid.id })}>{tid.description}</option>
      );
    });
  }

  const renderStatusOptions = () => {
    return statuses?.map((status) => {
      return (
        <option value={status.id} onClick={() => handleDropdownChange({ name: 'status', value: status.id })}>{status.status}</option>
      );
    });
  }

  const renderTable = () => {
    if (transactions.dataRows.length > 0) {
      return transactions.dataRows.map(tran => {
        return (
          <tr key={tran.txnRefNo}>
            <td>{tran.txnRefNo}</td>
            <td>{moment(tran.transactionDate).format('YYYY-MM-DD HH:mm:ss')}</td>
            <td>{tran.mid}</td>
            <td>{tran.tid}</td>
            <td className="text-right">{parseFloat(tran.amount).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</td>
            <td>{tran.status}</td>
          </tr>
        );
      });
    } else {
      return (
        <tr>
          <td colSpan="6" style={{ textAlign: "center" }}>
            <Label size="sm" className="mr-sm-2"><i>
              <MDBIcon icon="exclamation-triangle" /> No available transactions yet.</i>
            </Label>
          </td>
        </tr>
      );
    }
  };

  const redAsterisk = () => {
    return (
      <label className="red-asterisk">*</label>
    );
  }

  const renderPageNumbers = () => {
    if (page.totalCount !== null) {
      let totalPages = Math.ceil(page.totalCount / page.pageSize);

      if (totalPages > 10) {
        let maxPage = 10;
        let minPage = 1;
        if (totalPages >= maxPage) {
          if (transactions.currentPage >= maxPage) {
            maxPage = transactions.currentPage + 2;
            minPage = transactions.currentPage - 2;
          }

          if (minPage < 1)
            minPage = 1;

          if (maxPage >= totalPages)
            maxPage = totalPages;

          if ((maxPage - minPage) < 9)
            minPage = maxPage - 9;

          for (let i = minPage; i <= maxPage; i++) {
            pageNumbers.push(i)
          }
        }
        else {
          if (minPage < 1)
            minPage = 1;
          for (let i = minPage; i <= maxPage; i++) {
            pageNumbers.push(i)
          }
        }
      }
      else {
        for (let i = 1; i <= totalPages; i++) {
          pageNumbers.push(i)
        }
      }
    }

    return pageNumbers.map(number => {
      let classes = transactions.currentPage === number ? 'active' : '';

      return (
        <PaginationItem className={classes} key={number}>
          <PaginationLink onClick={() => handlePageChange({ value: number })}> {number} </PaginationLink>
        </PaginationItem>
      );
    });
  };

  const handleSearch = () => {
    getTransactions(1);
  }

  return (
    <div className="header bg-gradient-info pb-8 pt-5 pt-md-8">
      <div className="page-header">
        <h1>Transaction Inquiry</h1>
        <h3>Lists of the all transactions logged in the system.</h3>
        <p>
          <MDBIcon icon="link" className="text-green" fixed />
          <a className="text-green" href="/admin/index"> Dashboard</a> / Transaction Inquiry
        </p>
      </div>

      <Container>
        <Row>
          <div className="col">
            <Row>
              <Col md="12" xs="12">
                <Card className="card-stats mb-4 mb-xl-0 shadow">
                  <CardHeader className="border-0">
                    <h3 className="mb-0">Transactions {transactions.dataCount !== 0 ? `(${transactions.dataCount?.toLocaleString()})` : ''}
                    </h3>
                  </CardHeader>
                  <hr className="mt--0 divider" />
                  <CardBody>
                    <Row>
                      <Col>
                        <FormGroup>
                          <Label for="exampleEmail">Start Date {redAsterisk()}</Label>
                          <Input type="date" name="startDate" id="startDate" size="md" onChange={event => handleChange(event, event.target.value, event.target.name)} />
                        </FormGroup>
                        <FormGroup>
                          <Label for="exampleEmail">Coverage</Label>
                          <Input type="select" name="coverage" id="coverage" onChange={event => handleChange(event, event.target.value, event.target.name)}>
                            <option value="0"></option>
                            <option value="10">Last 10 Transactions</option>
                            <option value="30">Last 30 Transactions</option>
                            <option value="100">Last 100 Transactions</option>
                          </Input>
                        </FormGroup>
                      </Col>
                      <Col>
                        <FormGroup>
                          <Label for="exampleEmail">End Date {redAsterisk()}</Label>
                          <Input type="date" name="endDate" id="endDate" size="md" onChange={event => handleChange(event, event.target.value, event.target.name)} />
                        </FormGroup>
                        <FormGroup>
                          <Label for="exampleEmail">Status</Label>
                          <Input type="select" name="status" id="status" onChange={event => handleChange(event, event.target.value, event.target.name)}>
                            <option value=""></option>
                            {renderStatusOptions()}
                          </Input>
                        </FormGroup>
                      </Col>
                      <Col>
                        <FormGroup>
                          <Label for="exampleEmail">Merchant ID (MID) {redAsterisk()}</Label>
                          <Input type="select" name="mid" id="mid" onChange={event => handleChange(event, event.target.value, event.target.name)}>
                            {renderMIDOptions()}
                          </Input>
                        </FormGroup>
                        <FormGroup>
                          <Label for="exampleEmail">Transaction Reference</Label>
                          <Input size="md" name="txnRefNo" id="txnRefNo" onChange={event => handleChange(event, event.target.value, event.target.name)} />
                        </FormGroup>
                      </Col>
                      <Col>
                        <FormGroup>
                          <Label for="exampleEmail">Terminal ID (TID) {redAsterisk()}</Label>
                          <Input type="select" name="tid" id="tid" onChange={event => handleChange(event, event.target.value, event.target.name)}>
                            {renderTIDOptions()}
                          </Input>
                        </FormGroup>
                        <FormGroup>
                          <Button color="info" onClick={event => { handleSearch(event) }} style={{ marginTop: "31px", height: "48px" }}>
                            <MDBIcon icon="search" /> Search</Button>
                        </FormGroup>
                      </Col>
                    </Row>
                    <br />
                    <Table className="align-items-center table-flush" responsive>
                      <thead className="thead-light">
                        <tr>
                          <th>Txn Reference</th>
                          <th>Transaction Date</th>
                          <th>Merchant ID (MID)</th>
                          <th>Terminal ID (TID)</th>
                          <th className="text-right">Amount</th>
                          <th>Status</th>
                        </tr>
                      </thead>
                      <tbody>
                        {renderTable()}
                      </tbody>
                    </Table>
                    <CardFooter className="py-4">
                      <Row className="mt-0" hidden={!(Math.ceil(page.totalCount / page.pageSize) > 1)}>
                        <Col xl="6" l="6">
                          {pageShowing(page.totalCount, page.pageSize, page.currentPage)}
                        </Col>
                        <Col xl="6">
                          <Pagination className="pagination justify-content-end mb-0" listClassName="justify-content-end mb-0">
                            <PaginationItem>
                              <PaginationLink
                                onClick={() => handlePageChange({ value: (page.currentPage - 1) })}
                                tabIndex="-1"
                              >
                                <i className="fas fa-angle-left" />
                                <span className="sr-only">Previous</span>
                              </PaginationLink>
                            </PaginationItem>
                            {renderPageNumbers()}
                            <PaginationItem>
                              <PaginationLink
                                onClick={(e, val) => handlePageChange({ value: (page.currentPage + 1) })}
                                tabIndex="-1"
                              >
                                <i className="fas fa-angle-right" />
                                <span className="sr-only">Next</span>
                              </PaginationLink>
                            </PaginationItem>
                          </Pagination>
                        </Col>
                      </Row>
                    </CardFooter>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </div>
        </Row>
      </Container>

      <Modal isOpen={modal} toggle={toggle} >
        <ModalHeader toggle={toggle}>{modalTitle}</ModalHeader>
        <ModalBody>
          <center>
            <img src={qrSource} height="400" width="400" alt="qrImage"></img>
          </center>
        </ModalBody>
        <ModalFooter>
          <Button color="info" onClick={toggle}>Close</Button>
        </ModalFooter>
      </Modal>
    </div>
  );
}

export default TransactionInquiry;
